import * as io from 'socket.io-client'
import { getSocketUrl } from './utils/platform';

const socket = io(getSocketUrl());

export default socket;
